export default __webpack_public_path__ + "static/media/homeIconLarge.33314983.svg";